import { render } from "./CoursesList.vue?vue&type=template&id=0d399da2"
import script from "./CoursesList.vue?vue&type=script&lang=js"
export * from "./CoursesList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__